import { render, staticRenderFns } from "./FinalPhase.vue?vue&type=template&id=0a9b145a&scoped=true&"
import script from "./FinalPhase.vue?vue&type=script&lang=js&"
export * from "./FinalPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b145a",
  null
  
)

export default component.exports